import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full h-full flex flex-col justify-between overflow-auto scollbar" }
const _hoisted_2 = { class: "flex flex-col items-center gap-y-6" }
const _hoisted_3 = { class: "text-center text-xl sm:text-3xl" }
const _hoisted_4 = { class: "text-center text-2xl sm:text-4xl" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_custom_button = _resolveComponent("custom-button")!
  const _component_main_container = _resolveComponent("main-container")!

  return (_openBlock(), _createBlock(_component_main_container, { title: '' }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", null, null, -1)),
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("h1", { class: "text-center text-3xl sm:text-5xl" }, "404", -1)),
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.$t("404.error")), 1),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("404.page_not_loadable")), 1),
          _createVNode(_component_custom_button, {
            class: "mt-5",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'NormAdministration' })))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("404.back_to_start")), 1)
            ]),
            _: 1
          })
        ]),
        _cache[3] || (_cache[3] = _createElementVNode("div", null, null, -1)),
        _cache[4] || (_cache[4] = _createElementVNode("div", null, null, -1)),
        _cache[5] || (_cache[5] = _createElementVNode("div", null, null, -1))
      ])
    ]),
    _: 1
  }))
}